import React from "react";
import { useTheme } from "styled-components";
import {
  ArrowContainer,
  CallToActionContainer,
  CardContainer,
  CardContentContainer,
  CardHeading,
  CardLabel,
  CardParagraph,
  CardStep,
} from "./styles";
import EditableText from "../../inline-edit/EditableText";
import { CARDS_PROP } from "../../../../../../settings/features/cards/defaults";
import { Arrow } from "./Arrow";
import EditableInput from "../../inline-edit/EditableInput";

function StepsOne({ data, config, isEditable, index = 0 }) {
  const theme = useTheme();
  const twoDigitIndex = (index + 1).toLocaleString("en-US", {
    minimumIntegerDigits: 2,
  });

  const accentColor = data[CARDS_PROP.COLORS].accent[theme.name];
  const textColor = data[CARDS_PROP.COLORS].text[theme.name];

  const isFiveColumn = config.columns === 5;

  return (
    <CardContainer borderRadius={config.borderRadius}>
      <CardStep
        backgroundColor={accentColor}
        color={textColor}
        isFiveColumn={isFiveColumn}
      >
        {twoDigitIndex}
      </CardStep>

      <CardContentContainer>
        <CardHeading isFiveColumn={isFiveColumn}>
          {isEditable ? (
            <EditableText
              inputProp={CARDS_PROP.TITLE}
              data={data}
              config={config}
              customCalculatorStyles={{ minHeight: "1em" }}
            />
          ) : (
            data.title
          )}
        </CardHeading>
        {config.layout.includes(CARDS_PROP.TEXT) && (
          <CardParagraph>
            {isEditable ? (
              <EditableText
                inputProp={CARDS_PROP.TEXT}
                data={data}
                config={config}
              />
            ) : (
              data.text
            )}
          </CardParagraph>
        )}
      </CardContentContainer>

      {(config.layout.includes(CARDS_PROP.ARROW) ||
        config.layout.includes(CARDS_PROP.LINK_TEXT)) && (
        <CallToActionContainer>
          {config.layout.includes(CARDS_PROP.LINK_TEXT) ? (
            <CardLabel color={accentColor}>
              {isEditable ? (
                <EditableInput
                  inputProp={CARDS_PROP.LINK_TEXT}
                  data={data}
                  config={config}
                  customStyles={{ textAlign: "center" }}
                />
              ) : (
                data.linkText
              )}
            </CardLabel>
          ) : (
            <div />
          )}
          {config.layout.includes(CARDS_PROP.ARROW) && (
            <ArrowContainer color={accentColor}>
              <Arrow color={textColor} />
            </ArrowContainer>
          )}
        </CallToActionContainer>
      )}
    </CardContainer>
  );
}

export default StepsOne;
